import React, { useCallback, useEffect, useMemo, useState } from "react";
import LoadableComp from "../../commonComponents/LoadableComp/LoadableComp";
import "./KonfigurimiKandidateve.scss";
import { NewFieldModal } from "./NewFieldModal";
import { useDispatch, useSelector } from "react-redux";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { TickIcon, XIcon, IconLocked } from "../../../assets/icons";
import ConfirmModal from "./ConfirmModal";
import { PlusOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import { columnDefs } from "./HeaderNames";
import { useAuth } from "../../../../src/authentication/authHelpers.js";
import PermissionsModal from "../../DocumentationConfiguration/View/DocumentationPreview/PermissionsModal/PermissionsModal.jsx";
import { API } from "../../../helpers/API/amplifyApi";
import { message } from "antd";
import { programFields as programFieldsReducer } from "../../../store/actions/";
import CandidatesConfigKanban from "./CandidatesConfigKanban/CandidatesConfigKanban.jsx";
import NewStepModal from "./NewStepModal/NewStepModal.jsx";
import SettingsFooter from "../dynamic components/SettingsFooter/SettingsFooter.jsx";

const INTERVIEW_DOCS_PERMISSION_LIST_FIELD_ID =
  "345dgdf-456457fgjvbmn-96789khjghj";
// const CANDIDATE_CONFIG_FIELD_ID = "543gerger-dfgsdg-645645hfghfdghd"; kandidates 1
const CANDIDATE_CONFIGURATION_FIELD_ID = "a086b42f-cd92-4e6c-8e91-cfe78d66f07f"; //kandidates dummy

const KonfigurimiKandidateve = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const { programFields } = useSelector((state) => state.programFields);
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [rowData, setRowData] = useState([]);
  const [changes, setChanges] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [programField, setProgramField] = useState({});
  const [deletedFields, setDeletedFields] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(null);
  const [showNewStepModal, setShowNewStepModal] = useState(false);
  const [confirmChangesType, setConfirmChangesType] = useState("");
  const [showClearConfirmModal, setShowClearConfirmModal] = useState(false);
  const [permissionsModalVisible, setPermissionsModalVisible] = useState(false);

  const fieldCreatedBy =
    auth?.employee?.employeeFirstName + " " + auth?.employee?.employeeLastName;

  const handleConfirmButtons = (e) => {
    setConfirmChangesType(e);
    setShowClearConfirmModal(!showClearConfirmModal);
  };
  //region currentPermissions
  const currentPermissions = useMemo(() => {
    if (!!programFields?.length) {
      const index = programFields?.findIndex(
        ({ fieldId }) => fieldId === INTERVIEW_DOCS_PERMISSION_LIST_FIELD_ID
      );
      if (index > -1) {
        return programFields[index]?.fieldOptions;
      }
    } else return [];
  }, [programFields]);

  //region HANDLE PERMISSIONS
  const handlePermissions = async (list) => {
    await API.put(
      "programFields",
      `/programFields/${INTERVIEW_DOCS_PERMISSION_LIST_FIELD_ID}`,
      {
        body: {
          fieldOptions: list,
        },
      }
    )
      .then((res) => {
        if (!!res.status) {
          const newProgramFields = [...programFields];
          const index = newProgramFields.findIndex(
            ({ fieldId }) => fieldId === INTERVIEW_DOCS_PERMISSION_LIST_FIELD_ID
          );
          if (index > -1) {
            newProgramFields[index] = {
              ...newProgramFields[index],
              fieldOptions: list,
            };
            dispatch(programFieldsReducer(newProgramFields));
          }
          setPermissionsModalVisible(false);
          message.success("Aksesi u ndryshua me sukses!");
        }
      })
      .catch((err) => console.log("Error: ", err));
  };

  useEffect(() => {
    try {
      if (!!programFields?.length) {
        const TableData = programFields?.find(
          (el) => el?.fieldId === CANDIDATE_CONFIGURATION_FIELD_ID
        );
        if (!!TableData?.fieldOptions?.length) {
          let availableTableData = [];
          let deletedTableData = [];

          (TableData?.fieldOptions || []).forEach((option) => {
            let available = [];
            let deleted = [];
            option?.fields?.forEach((el) => {
              if (!!el?.deletedField) deleted.push(el);
              else available.push(el);
            });

            availableTableData.push({ ...option, fields: [...available] });
            deletedTableData.push({ ...option, fields: [...deleted] });
          });

          setProgramField(TableData);
          setRowData(availableTableData);
          setDeletedFields(deletedTableData);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }, [programFields]);

  //region RETURN
  return (
    <LoadableComp loading={!!Object.keys(rowData).length ? false : true}>
      <div className="globalPageWrapper">
        <div className={`konfigurimi-body ${isDarkMode ? "dark" : ""}`}>
          <div className="table-header">
            <p>Konfigurimi i Kandidatëve</p>
            <div className="headerButtons">
              <MondayButton
                {...{
                  className: "mondayButtonBlue",
                  onClick: () => setPermissionsModalVisible(true),
                  Icon: <IconLocked width={20} height={20} />,
                }}
              >
                Aksesi në Google Drive
              </MondayButton>
              <MondayButton
                {...{
                  onClick: () => {
                    setShowCreateModal([]);
                    // setModalType("Create")
                  },
                  Icon: <PlusOutlined />,
                  className: "mondayButtonGreen",
                }}
              >
                Shto fushë të re
              </MondayButton>
              <MondayButton
                {...{
                  onClick: () => {
                    setShowNewStepModal(true);
                    // setModalType("Create")
                  },
                  Icon: <PlusOutlined />,
                  className: "mondayButtonGreen",
                }}
              >
                Shto step të ri
              </MondayButton>
            </div>
          </div>
          <CandidatesConfigKanban
            data={rowData}
            setRowData={setRowData}
            groupBy={"step"}
            endpoint={"programFields"}
            programField={programField}
            onItemClick={setShowCreateModal}
            setChanges={setChanges}
            setDeletedFields={setDeletedFields}
            editColumn={setShowNewStepModal}
          />
        </div>
        {!!changes ? (
          <SettingsFooter
            visible={changes}
            children={[
              <MondayButton
                {...{
                  className: `whiteIconBackground ${
                    changes ? "mondayButtonRed " : "mondayButtonGray"
                  }`,
                  Icon: <XIcon height={10} width={10} />,
                  onClick: () => handleConfirmButtons("Cancel"),
                }}
              >
                Cancel Changes
              </MondayButton>,
              <MondayButton
                {...{
                  className: `${
                    changes ? "mondayButtonGreen " : "mondayButtonGray"
                  }`,
                  Icon: <TickIcon height={17} width={17} />,
                  onClick: () => handleConfirmButtons("Confirm"),
                }}
              >
                Save Changes
              </MondayButton>,
            ]}
          />
        ) : null}
      </div>
      {showCreateModal && (
        <NewFieldModal
          {...{
            showCreateModal,
            setShowCreateModal,
            rowData,
            setChanges,
            selectedRow,
            setSelectedRow,
            setRowData,
            fieldCreatedBy,
            programField,
          }}
        />
      )}
      {showNewStepModal && (
        <NewStepModal
          open={showNewStepModal}
          setOpen={setShowNewStepModal}
          programField={programField}
          editableStep={
            !!Object.keys(showNewStepModal || {}).length ? showNewStepModal : {}
          }
        />
      )}
      {showClearConfirmModal && (
        <ConfirmModal
          {...{
            showClearConfirmModal,
            confirmChangesType,
            setShowClearConfirmModal,
            rowData,
            setRowData,
            setChanges,
            deletedFields,
            programField,
            setProgramField,
          }}
        />
      )}
      {!!permissionsModalVisible && (
        <PermissionsModal
          {...{
            currentPermissions,
            onSave: handlePermissions,
            visible: permissionsModalVisible,
            setVisible: setPermissionsModalVisible,
          }}
        />
      )}
    </LoadableComp>
  );
};

export default KonfigurimiKandidateve;
